import { createFileRoute } from '@tanstack/react-router';
import { academicSeo } from '@/components/astro/pages/academic-landing-page';
import { FUNNEL_CAMPAIGN } from '@/components/funnel/config/funnels';
import { SqueezePage } from '@/components/funnel/squeeze/squeeze-page';
import { normalizeCanonicalUrl } from '@/seo/canonical';
import { seo } from '@/seo/seo';

export const Route = createFileRoute('/_marketing/academic-3')({
  head: () => ({
    meta: [...seo(academicSeo)],
    links: [{ rel: 'canonical', href: normalizeCanonicalUrl('/academic') }],
  }),
  component: AcademicPaywallFirstRoute,
});

function AcademicPaywallFirstRoute() {
  return <SqueezePage campaign={FUNNEL_CAMPAIGN} flow='paywall-first' />;
}
